import * as React from 'react';
import { Helmet } from 'react-helmet';

import { checkMetaTag } from '../../utilities';

export interface Props {
  tags: any;
}

export class MetaTags extends React.Component<Props, {}> {
  constructor(props) {
    super(props);
  }
  public render() {
    const { tags } = this.props;
    return (
      <React.Fragment>
        {tags !== {} && (
          <Helmet>
            {tags.title && <title>{checkMetaTag(tags.title)}</title>}

            {tags.metaDescription && (
              <meta
                name="description"
                content={checkMetaTag(tags.metaDescription)}
              />
            )}
            {tags.keywords && (
              <meta name="keywords" content={checkMetaTag(tags.keywords)} />
            )}
            {tags.og_title && (
              <meta name="og:title" content={checkMetaTag(tags.og_title)} />
            )}
            {tags.og_type && (
              <meta name="og:type" content={checkMetaTag(tags.og_type)} />
            )}
            {tags.og_description && (
              <meta
                name="og:description"
                content={checkMetaTag(tags.og_description)}
              />
            )}
            {tags.og_url && (
              <meta name="og:url" content={checkMetaTag(tags.og_url)} />
            )}
            {tags.og_image && (
              <meta name="og:image" content={checkMetaTag(tags.og_image)} />
            )}
            {tags.og_article_author && (
              <meta
                name="article:author"
                content={checkMetaTag(tags.og_article_author)}
              />
            )}
            {tags.og_article_section && (
              <meta
                name="article:section"
                content={checkMetaTag(tags.og_article_section)}
              />
            )}
            {tags.og_article_tag && (
              <meta
                name="article:tag"
                content={checkMetaTag(tags.og_article_tag)}
              />
            )}
          </Helmet>
        )}
      </React.Fragment>
    );
  }
}
